import type { SelectableField, SelectableFieldsResponse } from './selectableFields.types'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function normalizeList(value: unknown): SelectableField[] {
  if (!Array.isArray(value)) return []
  const seen = new Set<string>()
  const fields: SelectableField[] = []
  for (const item of value) {
    if (!isRecord(item) || typeof item.field !== 'string') continue
    const field = item.field.trim()
    if (!field || seen.has(field)) continue
    seen.add(field)
    const visibleName = typeof item.visible_name === 'string' ? item.visible_name.trim() : ''
    fields.push({
      field,
      visible_name: visibleName || field,
      sub_type: typeof item.sub_type === 'string' ? item.sub_type : '',
    })
  }
  return fields
}

/**
 * Legacy parity (`useSelectableFields.ts`'s `normalizeSelectableFields`): reads the body whether
 * it arrives enveloped (`{data: {dimensions, metrics}}`) or bare (`{dimensions, metrics}`
 * directly) rather than asserting one shape — ported as-is since the live response can't be
 * inspected ahead of time and old already carries this tolerance for this exact endpoint.
 */
export function parseSelectableFields(payload: unknown): SelectableFieldsResponse {
  const body = isRecord(payload) && isRecord(payload.data) ? payload.data : payload
  return {
    dimensions: normalizeList(isRecord(body) ? body.dimensions : undefined),
    metrics: normalizeList(isRecord(body) ? body.metrics : undefined),
  }
}
